import React, { memo } from 'react';

import { styled, type StyledProps } from '@compiled/react';
import { useIntl } from 'react-intl';

import UFOInteractionIgnore from '@atlaskit/react-ufo/interaction-ignore';
import Spinner from '@atlaskit/spinner/spinner';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip/Tooltip';

import messages from './messages';

type FieldBusyIndicatorProps = {
	isRequired?: boolean;
	fieldId: string;
	fieldName?: string;
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FieldBusyIndicator: React.NamedExoticComponent<FieldBusyIndicatorProps> =
	memo<FieldBusyIndicatorProps>(({ fieldId }: FieldBusyIndicatorProps) => {
		const { formatMessage } = useIntl();
		const loadingMessage = formatMessage(messages.fieldLevelIndicatorTooltipContent);
		const indicatorId = `issue-adjustments.ui.field-loading-indicator.${fieldId}`;
		const tooltipId = `issue-adjustments.ui.field-loading-indicator.tooltip.${fieldId}`;

		return (
			<Tooltip tag="span" content={loadingMessage} testId={tooltipId}>
				<BusyIconIndentsWrapper>
					<UFOInteractionIgnore>
						<Spinner testId={indicatorId} size="small" />
					</UFOInteractionIgnore>
				</BusyIconIndentsWrapper>
			</Tooltip>
		);
	});

FieldBusyIndicator.displayName = 'FieldBusyIndicator';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const BusyIconIndentsWrapper: React.ComponentType<
	React.ClassAttributes<HTMLSpanElement> & React.HTMLAttributes<HTMLSpanElement> & StyledProps
	// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
> = styled.span({
	marginLeft: token('space.075', '6px'),
});
